import React from 'react'
import { RichText } from '../../elements/RichText/component'
import { Text } from '../../elements/Text'
import { IProps } from './index'
import { Icon, renderIconSVG } from '../../utils'
import { Tooltip } from '../../elements/Tooltip'
import ProductIcon from 'marketing-site/src/images/product-icon.svg'
import ResolutionBotIcon from 'marketing-site/src/images/resolution-bot-icon.svg'
import ProactiveSupportIcon from 'marketing-site/src/images/proactive-support-icon-legacy.svg'
import CustomerService from 'marketing-site/src/images/customer-service.svg'
import WhatsAppIcon from 'marketing-site/src/images/whatsapp-icon.svg'
import SurveysIcon from 'marketing-site/src/images/post-filled-icon-legacy.svg'
import SwitchIcon from 'marketing-site/src/images/switch-icon.svg'
import SmsIcon from 'marketing-site/src/images/productIcons/product-sms.svg'
import { ADD_ON_OPTIONS } from '../FeaturesModal'
import useTranslate from '../../hooks/useTranslate'
import { FeaturesModalItem as FeaturesModalItemDefault } from './component'
import { NewBrandingHoc } from '../../utils/NewBrandingHoc'
import { FeatureTooltip } from '../FeatureTooltip'

enum TooltipIcons {
  Outbound,
  Apps,
  Inbox,
  Surveys,
  Bots,
  Reports,
  Series,
  ProductTours,
  Messnger,
  Notifications,
  Contacts,
  User,
  Articles,
  AtIcon,
}

const legacyIcons = {
  [TooltipIcons.Outbound]: ProactiveSupportIcon,
  [TooltipIcons.Bots]: ResolutionBotIcon,
  [TooltipIcons.ProductTours]: ProductIcon,
  [TooltipIcons.Surveys]: SurveysIcon,
}

function FeaturesModalItemLegacy({
  feature,
  values,
  showLegend = false,
}: IProps): React.ReactElement | null {
  const icons = legacyIcons

  const featureInPlan = values.find(({ featureKey }) => featureKey.name === feature.name)
  const { translate } = useTranslate()
  const hasNewTooltipModel =
    featureInPlan?.featureKey?.tooltip?.items &&
    featureInPlan?.featureKey?.tooltip?.items.length > 0 &&
    featureInPlan?.featureKey?.tooltip?.title

  if (!featureInPlan) {
    return null
  }

  if (featureInPlan.mainText) {
    return (
      <Text size="caption">
        <RichText html={featureInPlan.mainText} />
      </Text>
    )
  }
  if (showLegend && featureInPlan.featureKey.availableInAddOn) {
    const addonEyebrowText = translate('Available with add-on')

    const addOnTooltipProps = {
      'Proactive Support': {
        text: translate('Proactive Support'),
        eyebrow: addonEyebrowText,
        icon: icons[TooltipIcons.Outbound],
      },
      'Resolution bot': {
        text: translate('Resolution bot'),
        eyebrow: addonEyebrowText,
        icon: icons[TooltipIcons.Bots],
      },
      'Product tours': {
        text: translate('Product tours'),
        eyebrow: addonEyebrowText,
        icon: icons[TooltipIcons.ProductTours],
      },
      WhatsApp: {
        text: 'WhatsApp',
        eyebrow: addonEyebrowText,
        icon: WhatsAppIcon,
      },
      Surveys: {
        text: 'Surveys',
        eyebrow: addonEyebrowText,
        icon: icons[TooltipIcons.Surveys],
      },
      Switch: {
        text: 'Switch',
        eyebrow: addonEyebrowText,
        icon: SwitchIcon,
      },
      Sms: {
        text: 'Sms',
        eyebrow: addonEyebrowText,
        icon: SmsIcon,
      },
      PremierOnboarding: {
        text: 'Premier Onboarding',
        eyebrow: addonEyebrowText,
        icon: CustomerService,
      },
      PremierSuccess: {
        text: 'Premier Success',
        eyebrow: addonEyebrowText,
        icon: CustomerService,
      },
      PremierSupport: {
        text: 'Premier Support',
        eyebrow: addonEyebrowText,
        icon: CustomerService,
      },
    }

    const tooltipProps =
      addOnTooltipProps[featureInPlan.featureKey.addOnOption || ADD_ON_OPTIONS.ProcativeSupport]
    return (
      (hasNewTooltipModel && (
        <FeatureTooltip {...featureInPlan.featureKey.tooltip} above>
          {renderIconSVG(Icon.Plus)}
        </FeatureTooltip>
      )) || (
        <Tooltip {...tooltipProps} above>
          {renderIconSVG(Icon.Plus)}
        </Tooltip>
      )
    )
  }

  if (showLegend) {
    return renderIconSVG(Icon.FeatureCheckmark)
  }

  return renderIconSVG(Icon.Checkmark)
}

export const FeaturesModalItem = NewBrandingHoc(FeaturesModalItemLegacy, FeaturesModalItemDefault)
